<template>
  <div class="cps">
    <van-overlay :show="showCps">
      <div class="wrapper" @click.stop>
        <van-loading type="spinner" color="#1989fa" >Cps正在为您处理...</van-loading>
      </div>
    </van-overlay>
  </div>
</template>


<script>
import storejs from "store";
// import dayjs from "dayjs";
// import { mapActions } from "vuex";
import { Overlay,Loading } from 'vant';


export default {
  name:'Cps',
  components:{
    [Overlay.name]:Overlay,
    [Loading.name]:Loading
  },
  data(){
    return{
      cpsId:this.$route.params.iid,
      showCps:true
    }
  },
  mounted() {
    document.title = '希望保cps验证'
    // console.log(this.cpsId)
    if( navigator.userAgent.match(/Android/i)
		|| navigator.userAgent.match(/webOS/i)
		|| navigator.userAgent.match(/iPhone/i)
		|| navigator.userAgent.match(/iPad/i)
		|| navigator.userAgent.match(/iPod/i)
		|| navigator.userAgent.match(/BlackBerry/i)
		|| navigator.userAgent.match(/Windows Phone/i)
  	){
      this.getPub()
    }else{

    }
	
    
  },
  methods:{
    async getPub(){
      let res = await this.$http.post("api/accountLogin/getAccountBasicByUrl", {
        shareUrl:this.cpsId
      }); 
      console.log(res)
      if(res.code == 0){
        localStorage.removeItem('permissions')
        localStorage.removeItem('publicData')
        // storejs.set('permissions', ['产品']);
        //把iid写入storejs
        // storejs.set('iid', res.t.iid);
        //把所有信息都写入storejs备用
        res.t.isShare = true
        storejs.set('publicData', res.t);
        if(this.$route.query.e){
          location.href = '/index?' + 'c=' + this.cpsId + '&e=' + this.$route.query.e
        }else{
          location.href = '/index?' + 'c=' + this.cpsId 
        }
      }else{
        this.showCps = false;
        if(res.msg){
          this.$toast(res.msg)
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.block {
  width: 120px;
  height: 120px;
  background-color: #fff;
}
</style>

